import { TourOrExperience } from './../models/booking.model';
import { Package } from 'app/shared/models/booking.model';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import * as error from '../../shared/components/error-summary/error-handler.function';
import { UpdatePassengerOption } from '../../shared/models/passenger.model';
import { Booking, Totals, Farebasis } from '../../shared/models/booking.model';
import { GxConstants } from '../constants/gx.constants';
import internal from 'assert';

@Injectable()
export class TravelProductService {

    private verifySinglePassBookingUrl = '/umbraco/api/booking/VerifySinglePassBooking';
    private getPackagesUrl = '/umbraco/api/travel/GetPackages';
    private getPackageUrl = '/umbraco/api/travel/GetPackage';
    private getTourExperienceUrl = '/umbraco/api/travel/GetTourExperience';
    private getCountryUrl = '/umbraco/api/travel/GetCountries';
    private createBookingsUrl = '/umbraco/api/booking/CreateBookings';
    private addProductAndPassengerToBookingUrl = '/umbraco/api/booking/AddProductAndPassengerToBooking';
    private updatePassengerUrl = '/umbraco/api/passenger/UpdatePassenger';
    private updateInclusionsUrl = '/umbraco/api/travel/UpdateInclusion';
    private updateSingleInclusionsUrl = '/umbraco/api/travel/UpdateSingleInclusion';
    private addTourToBookingUrl = '/umbraco/api/travel/AddTourToBooking';
    private updateTourOnBookingUrl = '/umbraco/api/travel/UpdateTourOnBooking';
    private applyPromoToPackageUrl = '/umbraco/api/travel/ApplyPromoToPackage';
    private applyPromoToPassUrl = '/umbraco/api/travel/ApplyPromoToPass';
    private removePromoFromPackageUrl = '/umbraco/api/travel/RemovePromoFromPackage';
    private removePromoFromPassUrl = '/umbraco/api/travel/RemovePromoFromPass';
    private applyPromoToTourUrl = '/umbraco/api/travel/ApplyPromoToTour';
    private removePromoFromTourUrl = '/umbraco/api/travel/RemovePromoFromTour';
    private getCartTotalUrl = '/umbraco/api/booking/GetCartTotal';
    private getCartTotalForManagementUrl = '/umbraco/api/booking/GetCartTotalForManagement';
    private postCartTotalUrl = '/umbraco/api/booking/carttotal';
    private addCustomerToBookingUrl = '/umbraco/api/booking/AddCustomerToBooking';
    private confirmBookingUrl = '/umbraco/api/booking/ConfirmBooking';
    private confirmBookingKMPaymentUrl = '/umbraco/api/booking/ConfirmBookingKMPayment';
    private ticketBookingUrl = '/umbraco/api/booking/TicketBooking';
    private isProductInRegionUrl = '/umbraco/api/booking/IsProductInRegion';
    private allocateVisaNumberUrl = '/umbraco/api/booking/AllocateVisaNumber';

    private _currentPackage: TravelPackage | TravelTour;
    get currentProduct(): TravelPackage | TravelTour {
        return this._currentPackage;
    }
    set currentProduct(currentPackage: TravelPackage | TravelTour) {
        this._currentPackage = currentPackage;
    }

    public bookings: Array<Booking>;

    constructor(private http: Http) { }

    verifySinglePassBooking(verifySinglePassBookingOptions: VerifySinglePassBookingOptions): Observable<any> {
        return this.http.post(this.verifySinglePassBookingUrl, verifySinglePassBookingOptions)
            .map(res => res.json())
            .catch(error.handleError);
    }

    getPackages(): Observable<TravelPackage[]> {
        return this.http.get(this.getPackagesUrl)
            .map(this.extractPackages)
            .catch(error.handleError);
    }

    getPackage(packageReference: string): Observable<TravelPackage> {
        return this.http.get(`${this.getPackageUrl}?packageReference=${packageReference}`)
            .map(this.extractPackage)
            .catch(error.handleError);
    }
    getTourExperience(tourReference: string): Observable<TravelPackage> {
        return this.http.get(`${this.getTourExperienceUrl}?tourReference=${tourReference}`)
            .map(this.extractPackageForExperiences)
            .catch(error.handleError);
    }

    getCountries(): Observable<any> {
        return this.http.get(`${this.getCountryUrl}`)
            .map(res => res.json())
            .catch(error.handleError);
    }

    createBookings(createBookingsOption: CreateBookingsOption): Observable<Booking[]> {
        return this.http.put(`${this.createBookingsUrl}`, createBookingsOption)
            .map(res => res.json())
            .catch(error.handleError);
    }

    addProductAndPassengerToBooking(addProductAndPassengerToBookingOptions: AddProductAndPassengerToBookingOptions): Observable<any> {
        return this.http.put(`${this.addProductAndPassengerToBookingUrl}`, addProductAndPassengerToBookingOptions)
            .map(res => [res.json()])
            .catch(error.handleError);
    }

    updatePassenger(options: UpdatePassengerOption): Observable<any> {
        return this.http.post(`${this.updatePassengerUrl}`, options)
            .map(res => res.json())
            .catch(error.handleError);
    }

    updateInclusions(options: UpdateInclusionsOptions): Observable<any> {
        return this.http.post(`${this.updateInclusionsUrl}`, options)
            .map(res => res.json())
            .catch(error.handleError);
    }

    updateSingleInclusions(options: UpdateInclusionsOptions): Observable<any> {
        return this.http.post(`${this.updateSingleInclusionsUrl}`, options)
            .map(res => res.json())
            .catch(error.handleError);
    }

    addTourToBooking(options: AddTourToBookingOption): Observable<any> {
        return this.http.put(`${this.addTourToBookingUrl}`, options)
            .map(res => res.json())
            .catch(error.handleError);
    }

    updateTourOnBooking(options: UpdateTourOnBookingOption): Observable<any> {
        return this.http.post(`${this.updateTourOnBookingUrl}`, options)
            .map(res => res.json())
            .catch(error.handleError);
    }

    applyPromoToPackage(options: ApplyPromoToPackageOptions): Observable<Booking> {
        return this.http.put(`${this.applyPromoToPackageUrl}`, options)
            .map(res => Object.assign(new Booking(), res.json()))
            .catch(error.handleError);
    }
    applyPromoToPass(options: ApplyPromoToPackageOptions): Observable<Booking> {
        return this.http.put(`${this.applyPromoToPassUrl}`, options)
            .map(res => Object.assign(new Booking(), res.json()))
            .catch(error.handleError);
    }

    removePromoFromPackage(options: RemovePromoFromPackage): Observable<Booking> {
        return this.http.post(`${this.removePromoFromPackageUrl}`, options)
            .map(res => Object.assign(new Booking(), res.json()))
            .catch(error.handleError);
    }
    removePromoFromPass(options: RemovePromoFromPass): Observable<Booking> {
        return this.http.post(`${this.removePromoFromPassUrl}`, options)
            .map(res => Object.assign(new Booking(), res.json()))
            .catch(error.handleError);
    }

    applyPromoToTour(options: ApplyPromoToTourOptions): Observable<Booking> {
        return this.http.put(`${this.applyPromoToTourUrl}`, options)
            .map(res => Object.assign(new Booking(), res.json()))
            .catch(error.handleError);
    }

    removePromoFromTour(options: RemovePromoFromTour): Observable<Booking> {
        return this.http.post(`${this.removePromoFromTourUrl}`, options)
            .map(res => Object.assign(new Booking(), res.json()))
            .catch(error.handleError);
    }

    getCartTotal(bookingGuid: string): Observable<any> {
        return this.http.get(`${this.getCartTotalUrl}?bookingGuid=${bookingGuid}`)
            .map(res => res.json())
            .catch(error.handleError);
    }

    getCartTotalForManagement(bookingGuid: string): Observable<any> {
        return this.http.get(`${this.getCartTotalForManagementUrl}?bookingGuid=${bookingGuid}`)
            .map(res => res.json())
            .catch(error.handleError);
    }

    postCartTotal(options: GetCartTotalOptions): Observable<Totals> {
        return this.http.post(this.postCartTotalUrl, options)
            .map(res => Object.assign(new Totals(), res.json()))
            .catch(error.handleError);
    }

    addCustomerToBooking(bookingGuid: string, customerGuid: string): Observable<any> {
        return this.http.post(`${this.addCustomerToBookingUrl}`, new AddCustomerToBookingOption(bookingGuid, customerGuid))
            .map(res => res.json())
            .catch(error.handleError);
    }

    confirmBooking(bookingGuid: string): Observable<any> {
        return this.http.get(`${this.confirmBookingUrl}?bookingGuid=${bookingGuid}`)
            .map(res => res.json())
            .catch(error.handleError);
    }

    confirmBookingKMPayment(bookingGuid: string): Observable<any> {
        return this.http.get(`${this.confirmBookingKMPaymentUrl}?bookingGuid=${bookingGuid}`)
            .map(res => res.json())
            .catch(error.handleError);
    }
    ticketBooking(options: TicketBookingOptions): Observable<any> {
        return this.http.put(`${this.ticketBookingUrl}`, options)
            .map(res => res.json())
            .catch(error.handleError);
    }
    isProductInRegion(fareCode: string): Observable<any> {
        return this.http.get(`${this.isProductInRegionUrl}?fareCode=${fareCode}`)
        .map(res => res.json())
        .catch(error.handleError);
    }
    allocateVisaNumber(bookingNumber: string, visaNumber : string): Observable<any> {
        return this.http.get(`${this.allocateVisaNumberUrl}?bookingNumber=${bookingNumber}&visaNumber=${visaNumber}`)
        .map(res => res.json())
        .catch(error.handleError);
    }
    private extractPackage = (res: Response) => {
        const body = res.json();
        return this.constructPackage(body);
    }

    private extractPackageForExperiences = (res: Response) => {
        const body = res.json();
        return this.constructPackageForExperiences(body);
    }

    private constructPackage(body: Package) {
        const fareTypes = body.FareTypes
            // tslint:disable-next-line:max-line-length
            .map(f => new FareType(f.FareTypeCode, f.OnlineName, f.Farebasis.InternetDescription, f.Farebasis.TotalPrice, (<any>f.Farebasis).SalePriceKM, f.Farebasis));

        return new TravelPackage(body.Image2,
            body.Name,
            body.Description,
            body.PackageReference,
            null,
            fareTypes);
    }
    private constructPackageForExperiences(body: TourOrExperience) {
        const fareTypes = body.FareTypes.
            map(f => new FareType(f.FareTypeCode, f.OnlineName, f.Description, f.SalePrice, f.SalePriceKM, f.Farebasis));

        return new TravelPackage(body.Image2,
            body.Name,
            body.Description,
            null,
            body.TourReference,
            fareTypes);
    }

    private extractPackages = (res: Response) => {
        const body = res.json();
        return body.map(c => this.constructPackage(c));
    }
}

export class AllocateVisaNumberOptions {
    constructor(private bookingNumber: string, private visaNumber: string, private visaPromoCode: string = null) {}
}

export class VerifySinglePassBookingOptions {
    constructor(private bookingNumber: string, private bookingPin: string) { }
}


export class ApplyPromoToPackageOptions {
    constructor(private promotionCode: string, private bookingGuid: string) { }
}

export class RemovePromoFromPackage {
    constructor(private bookingGuid: string, private packageGuid: string) { }
}

export class RemovePromoFromPass {
    constructor(private bookingGuid: string, private passGuid: string) { }
}

export class ApplyPromoToTourOptions {
    constructor(private promotionCode: string, private bookingGuid: string, private tourGuid: string) { }
}

export class RemovePromoFromTour {
    constructor(private bookingGuid: string, private tourGuid: string) { }
}

export class UpdateInclusionsOptions {
    constructor(private dateToBook: string, private bookingGuid: string, private tourGuid: string) { }
}

export class AddTourToBookingOption {
    constructor(
        private bookingGuid: string,
        private tourGuid: string,
        private dateToBook: string,
        private fareTypeCode: string,
        private fareTypeCurrency: string,
        private fareTypeCurrencyAmount: number,
        private sendConfirmation: boolean
    ) { }
}
export class UpdateTourOnBookingOption {
    constructor(
        private bookingGuid: string,
        private tourGuid: string,
        private dateToBook: string,
        private fareTypeCode: string,
        private fareTypeCurrency: string,
        private fareTypeCurrencyAmount: number,
        private sendConfirmation: boolean
    ) { }
}

export class AddCustomerToBookingOption {
    constructor(private bookingGuid: string, private customerGuid: string) { }
}

export class TravelPackage {
    fareTypes: Array<FareType>;
    constructor(
        public icon,
        public title,
        public description,
        public packageReference,
        public tourReference: string,
        fareTypes?: Array<FareType>) {
        this.fareTypes = fareTypes;
    }
}
export class TravelTour extends TravelPackage {
}

export class FareType {
    public salePrice: number;
    // tslint:disable-next-line:max-line-length
    constructor(public fareTypeCode: string, public displayDescription: string, public internetDescription: string, public totalPrice: number, public salePriceKM: number, public farebasis: Farebasis) { }

    get descriptionToDisplay(): string {
        return this.displayDescription ? this.displayDescription : this.internetDescription;
    }
}

export class FareTypeChangedEvent {
    constructor(public fareType: FareType, public count: number) { }
}

export class CreateBookingsOption {
    public Company: string;
    public Currency: string;
    public ProductType: string;
    public CustomerGUID: string;
    public Products: ProductType[];

    constructor() {
        this.Company = GxConstants.COMPANY;
        this.Currency = GxConstants.CURRENCY;
        this.ProductType = GxConstants.PRODUCT_TYPE.BUSPASS;
    }
}

export class ProductType {
    public Product: string;
    public Reference: string;
    public FareType: string;
    public Quantity: number;
    public PromotionCode: string;
    public DateToBook: string;

    constructor(ref: string, fareTypeCode: string, count: number, product: string) {
        this.Reference = ref;
        this.FareType = fareTypeCode;
        this.Quantity = count;
        this.Product = product;
    }
}

export class TicketBookingOptions {
    constructor(public bookingGuid: string, public receiptNumber: string, public paymentGateway: string, public paymentType: string) { }
}

export class AddProductAndPassengerToBookingOptions {
    public Products: ProductType[];
    constructor(public bookingGuid: string) { }
}
export class CartItemOptions {
    public Name: string;
    public productCode: string;
    public PromoCode: string;
    public Quantity: number;
    public SalePriceUnit: number;
    public Type: string;
    public ProductReference: string;
    public FareReference: string;
    public ProductType: string;
}
export class GetCartTotalOptions {
    public BookingGUID: string;
    public CustomerGUID: string;
    public Farebasis: string
    public FreeTrip: boolean;
    public Passengers: number;
    public CartItems: CartItemOptions[];
}



// WEBPACK FOOTER //
// ./src/app/shared/services/travel-product.service.ts